module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-300.5f5c806f.svg";